module.exports = __webpack_public_path__ + "static/media/icon-notes.377ed8dd.svg";